{
	"title": "Tillgängliga material",
	"showAllTitle": "Visa alla material",
	"table": {
		"material": "Material",
		"invoicedQuantity": "Fakturerad kvantitet",
		"remainingForTransfer": "Återstår för skapande av deklaration",
		"fetchError": "Det gick inte att hämta material",
		"noMaterials": {
			"title": "Inga material tillgängliga",
			"description": "Du har för närvarande inga material tillgängliga på {{productName}}. Kontakta din säljrepresentant för att lägga till ditt/dina kontrakt till ditt konto."
		}
	}
}
